import React, { FC } from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ArrowDown } from 'common/const/svg';
import { useAppDispatch } from 'common/hooks';
import { ERoute } from 'common/const/enum';
import { EEventActionType, EEventType, EEventTypeLabel } from 'entities/Events/Event.enum';

interface IComponentProps {
  type?: string;
}

export const EventHeader: FC<IComponentProps> = ({ type = EEventType.Call }) => {
  const { event: eventDispatch } = useAppDispatch();
  const navigate = useNavigate();

  const onBackClick = () => {
    eventDispatch.setAction(EEventActionType.Back);
    navigate(ERoute.Dashboard);
  };

  return (
    <div className="d-flex align-center event__header">
      <Button className="event__header-btn" icon={<ArrowDown />} onClick={onBackClick}>
        Dashboard
      </Button>

      <span className="ff-regular fs-xsm color-grey">{` - ${EEventTypeLabel[type as EEventType]}`}</span>
    </div>
  );
};
